import { h, Component } from 'preact';
import style from './style';
import { trackingProvider, STANDARD_KEYS } from '@cube/track';

export const canRender = () => true;
export const getLink = ({ uri }) => uri;

@trackingProvider({
	[STANDARD_KEYS.cubecomponent]: 'Ad'
})
export class Card extends Component {

	render({ cardTypeCount }) {
		let id = 'dcc_slide_ad_' + cardTypeCount;
		return <div class={style.ad} id={id} />;
	}
}

const Ad = {
	canRender,
	getLink,
	Card
};
export default Ad;



// WEBPACK FOOTER //
// ../node_modules/@cube/dcc-widget-v2/src/components/cards/ad/index.js